import Col from './col';

export default Col;
